import React from "react";

const Modal = ({setTermoAceito, setShowModal, children}) => {

    const onClose = () => {
        setShowModal(_ => false)
        document.body.style.overflowY = 'unset';
    };

    return(
        <div id="termoModal" className="modal modal-resize center">
            <div className="modal-content">
                <button className="btTransparente right" onClick={() => onClose()}>
                    <span className="close">&times;</span>
                </button>
                <div className="termoAceite">
                    {children}
                </div>
                <div className="btsalvar">
                    <button className="btsalvar"
                        type="button"
                        onClick={() => {
                            if(setTermoAceito) {
                                setTermoAceito(_ => true)
                            }
                            onClose();
                        }}
                    >
                            Aceitar
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Modal;